import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import axios from "axios";
import toastr from "toastr";
import { CustomDropdown } from "./CustomDropdown";
import CustomToolTip from "./CustomToolTip";
import InfoBox from "./InfoBox";

interface NewFixedCampaignModalProps {
    showNewFixedCampaignModal: boolean;
    closeModal: () => void;
    refreshCampaigns: () => void;
    policy_id: string;
    accrualFrequency: string | null;
    setParentLoading: (val: boolean) => void;
    onFailedStart: () => void;
}

const FREQUENCY_OPTIONS = ["None", "Monthly", "Quarterly", "Semiannually"];

const NewFixedCampaignModal: React.FC<NewFixedCampaignModalProps> = ({
    showNewFixedCampaignModal,
    closeModal,
    refreshCampaigns,
    policy_id,
    accrualFrequency,
    setParentLoading,
    onFailedStart
}) => {
    const [campaignFrequency, setCampaignFrequency] = useState<string>(
        accrualFrequency ?? "None"
    );
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleStartCampaign = async () => {
        if (isSubmitting) return;

        setIsSubmitting(true);
        setParentLoading(true);

        try {
            const response = await axios.post("/api/FixedCampaign/addpolicyfixedcampaign", {
                PolicyId: policy_id,
                CampaignFrequency: campaignFrequency === "None" ? null : campaignFrequency
            });

            if (response.data?.success) {
                toastr.success("Campaign started successfully");
                closeModal();
                refreshCampaigns();
            } else {
                toastr.error(response.data?.message || "Failed to start campaign");
                onFailedStart();
            }
        } catch {
            toastr.error("Failed to start campaign");
            onFailedStart();
        } finally {
            setIsSubmitting(false);
            setParentLoading(false);
        }
    };

    const showAccrualDropdown = !!accrualFrequency;

    return (
        <Modal
            className="react-modal edit-campaign-modal"
            show={showNewFixedCampaignModal}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header>
                <Modal.Title>Start New Year Plan</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <InfoBox>
                    <p style={{ marginTop: 8 }}>
                        Starting a New Year Plan will create the upcoming benefit year and prepare
                        employee new year benefit based on the current policy configuration.
                    </p>
                </InfoBox>
                {showAccrualDropdown && (
                    <div
                        className="RT-TextBox"
                        style={{ backgroundColor: "white", padding: "15px 20px", marginTop: 20 }}
                    >
                        <label className="RT-Label" style={{ paddingLeft: 10 }}>
                            Scheduled Credits Frequency
                            <CustomToolTip
                                header="Scheduled Credits Frequency"
                                bodyContent="Confirm the frequency for next year's Scheduled Credits. Only Ops users may change this value."
                            />
                        </label>

                        <CustomDropdown
                            options={FREQUENCY_OPTIONS}
                            selectedOption={campaignFrequency}
                            setSelectedOption={setCampaignFrequency}
                        />
                    </div>
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={closeModal} disabled={isSubmitting}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleStartCampaign} disabled={isSubmitting}>
                    Start
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default NewFixedCampaignModal;
